import { CalendarActions } from './calendar.event.types';

export const WEEK_VIEW = 'week';
export const MONTH_VIEW = 'month';
export const DAY_VIEW = 'day';
export const AGENDA_VIEW = 'agenda';

export const CALENDAR_EVENT_SELECTED: CalendarActions = 'CALENDAR_EVENT_SELECTED';
export const CREATE_CALENDAR_EVENT: CalendarActions = 'CREATE_CALENDAR_EVENT';


// WEBPACK FOOTER //
// ./src/calendar/calendar.constants.tsx